<template>
    <LoadingComponent :props="loading" />
    <section class="slider-section mb-0 px-3">
        <div class="container relative slider-container">
            <Swiper
                v-if="sliders.length > 0"
                dir="rtl"
                :slides-per-view="1"
                :speed="1000"
                :loop="true"
                :navigation="true"
                :pagination="{ clickable: true }"
                :autoplay="{ delay: 2500 }"
                :modules="modules"
                class="banner-swiper rounded-2xl overflow-hidden super-border"
            >
                <SwiperSlide v-for="slider in sliders">
                    <div v-if="slider.link">
                        <a :href="slider.link">
                            <img class="w-full" :src="slider.image" alt="banner" >
                        </a>
                    </div>
                    <div v-else>
                        <img class="w-full" :src="slider.image" alt="banner" >
                    </div>
                </SwiperSlide>
            </Swiper>
            <div class="scroll-hint">
                <i class="fa-solid fa-angles-down text-3xl text-white"></i>
            </div>
            <div v-if="env.IMG_BANNER" class="img-banner">
                <img :src="env.IMG_BANNER" class="w-full h-full object-cover" alt="Banner" />
            </div>
        </div>
    </section>
</template>

<script>
import 'swiper/css';
import {Navigation, Pagination, Autoplay} from 'swiper/modules';
import {Swiper, SwiperSlide} from 'swiper/vue';
import statusEnum from "../../../enums/modules/statusEnum";
import LoadingComponent from "../components/LoadingComponent";
import env from "../../../config/env";

export default {
    name: "SliderComponent",
    components: {
        Swiper,
        SwiperSlide,
        LoadingComponent
    },
    setup() {
        return {
            modules: [Navigation, Pagination, Autoplay],
        }
    },
    data() {
        return {
            env: env,
            loading: {
                isActive: false
            },
            sliderProps: {
                search: {
                    paginate: 0,
                    order_column: 'id',
                    order_type: 'desc',
                    status: statusEnum.ACTIVE
                }
            }
        }
    },
    computed: {
        sliders: function () {
            return this.$store.getters['frontendSlider/lists'];
        }
    },
    mounted() {
        this.loading.isActive = true;
        this.$store.dispatch("frontendSlider/lists", this.sliderProps.search).then((res) => {
            this.loading.isActive = false;
        }).catch((err) => {
            this.loading.isActive = false;
        });
    }
}
</script>
